<template>
  <div class="antv-chart-mini">
    <div class="chart-wrapper" :style="{ height: 46 }">
      <v-chart :force-fit="true" :height="height" :data="chartData" :scale="scale" :padding="[36, 5, 18, 5]">
        <!--y为0时不会提示-->
        <v-tooltip :shared="false" :hideMarkers="false" title="x" />
        <v-bar position="x*y" :color="color" />
      </v-chart>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
const tooltip = [
  'x*y',
  (x, y) => ({
    name: x,
    value: y
  })
]

/* const scale = [{
  dataKey: 'x',
  min: 2
}, {
  dataKey: 'y',
  title: '时间',
  min: 1,
  max: 30
}] */

export default {
  name: 'MiniBar',
  props: {
    color:　{
      type: String,
      default: '#1890FF'
    },
    tipAlias: {
      type: String,
      default: "y",
    },
    chartData: {
      type: Array,
      default: () => [
        {
          x: 1,
          y: 2,
          z: 3
        },
      ],
    }
  },
  data () {
    return {
      tooltip,
      scale: [{
          dataKey: 'x',
      }, {
          dataKey: 'y',
          alias: this.tipAlias,
      }],
      height: 88
    }
  },
  watch: {
    /* chartData(val) {
      console.log("bar数据", val);
    }, */
  }
}
</script>

<style lang="scss" scoped>
  @import "chart";
</style>
